import { CardListContainer } from 'ui';

import { Contract } from '~/data';

import { ContractCard } from '../shared/ContractCard';

export const ContractCardList = ({ list }: { list: Contract[] }) => {
  return (
    <CardListContainer
      elements={list.map((contract) => {
        return <ContractCard key={contract.contractNumber} {...contract} />;
      })}
    />
  );
};
